import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE, STORAGE_KEYS } from "../config/vars";

export async function getMe() {
    try {
        const res = await apiFetch(`${API_BASE}/login/me`);
        if (!res.ok) return null;
        return res.json();
    } catch (_) {
        return null;
    }
}

export async function logout() {
    try {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    } catch (_) {
        // ignore
    }

    try {
        await apiFetch(`${API_BASE}/login/logout`, {
            method: "POST",
        });
    } catch (_) {
        // ignore network errors during logout
    }
}
